import React from 'react';
import {Container, Row} from 'react-bootstrap';

import {domains} from '../domains';
import {ICON} from '../fsg_icons';

import AppLink from './AppLink';
import styles from './css/AppDropdowns.module.css';

const InternalApps = props => {
	const rowClassName = `${styles.maxWidth} no-gutters`;
	return (
		<Container className="p-0">
			<Row className={rowClassName}>
				<AppLink onClick={props.onClick} icon={ICON.ALERTS} link={`${domains.alertsDomain}/#`} text="Alerts" />
				<AppLink onClick={props.onClick} icon={ICON.ANALYTICS} link={`${domains.analyticsDomain}/#`} text="Analytics" />
				<AppLink onClick={props.onClick} icon={ICON.CMS} link={`${domains.cmsDomain}/#cms`} text="CMS" />
			</Row>
			<Row className={rowClassName}>
				<AppLink
					onClick={props.onClick}
					icon={ICON.INDEX}
					transform="rotate(270, 256, 256)"
					link={`${domains.cmsDomain}/#index`}
					text="CMS Indices"
				/>
				<AppLink
					onClick={props.onClick}
					icon={ICON.GLOBE}
					noFlip
					link={`${domains.cmsDomain}/#cms/customRegion`}
					text="Custom Regions"
				/>
				<AppLink onClick={props.onClick} icon={ICON.DATA_ADMIN} link={`${domains.kuiDomain}`} text="Data Admin" />
			</Row>
			<Row className={rowClassName}>
				<AppLink
					onClick={props.onClick}
					icon={ICON.FORECASTING_ADMIN}
					link={`${domains.kuiDomain}/forecasts`}
					text="Forecast Admin"
				/>
				<AppLink
					onClick={props.onClick}
					icon={ICON.GIF_LIBRARY}
					noFlip
					link="https://fv.works/fv-gif-library"
					text="FV GIF Library"
					newTab={true}
				/>
				<AppLink
					onClick={props.onClick}
					icon={ICON.BANDERA}
					transform="scale(0.4)"
					link="https://fv.works/bandera"
					text="Get Bandera"
					newTab={true}
				/>
			</Row>
			<Row className={rowClassName}>
				<AppLink
					onClick={props.onClick}
					icon={ICON.MARKETING}
					link={`${domains.cmsDomain}/#marketing`}
					text="Marketing"
				/>
				<AppLink onClick={props.onClick} icon={ICON.MMM} link={`${domains.mmmDomain}/#`} text="MMM Builder" />
				<AppLink
					onClick={props.onClick}
					icon={ICON.SITE_STATUS}
					link={`${domains.statusDomain}/#`}
					text="Site Status"
				/>
			</Row>
			<Row className={rowClassName}>
				<AppLink
					onClick={props.onClick}
					icon={ICON.TICKET}
					link={`${domains.legacyFvDomain}/#tickets`}
					text="Ticket Taker"
				/>
				<AppLink
					onClick={props.onClick}
					icon={ICON.URL_GENERATOR}
					link={`${domains.cmsDomain}/#urls`}
					text="URL & QR Generator"
				/>
				<AppLink
					onClick={props.onClick}
					icon={ICON.USERS}
					noFlip
					link={`${domains.bartDomain}/#manage/users`}
					text="Users"
				/>
			</Row>
			<Row className={rowClassName}>
				<AppLink
					onClick={props.onClick}
					icon={ICON.VIEW_TICKETS}
					link={`${domains.legacyFvDomain}/#tickets/view`}
					text="View Tickets"
				/>
			</Row>
		</Container>
	);
};

export {InternalApps};
